// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react: true*/
import React, {Fragment, useContext} from 'react';
import {Trans, useTranslation} from 'react-i18next';
// @ts-ignore
import {App_context} from '/www/hola/pub/context.js';
import styles from './get_hola_top.module.less';
import Icon_netflix_logo from '../img/svg/icon/netflix_logo.svg';
import Icon_disney_logo from '../img/svg/icon/disney_logo.svg';
import Icon_hulu_logo from '../img/svg/icon/hulu_logo.svg';
import Icon_prime_logo from '../img/svg/icon/prime_logo.svg';
import Icon_youtube_logo from '../img/svg/icon/youtube_logo.svg';
import Icon_hbo_logo from '../img/svg/icon/hbo_logo.svg';
import {Svg} from './svg';
import {Button} from '../lib/button';
import {Trustpilot} from './trustpilot';
import {perr} from 'hola_pub_util';
import {Aff_icon} from './aff_icon';

interface i_p {
    pref?: string,
    fix?: number,
    sub_title?: string|JSX.Element,
    from?: number,
    aff_conf?:any
}
export const Get_hola_top = ({pref, fix, sub_title, from, aff_conf}:i_p)=>{
    // @ts-ignore
    const {is_client} = useContext(App_context);
    const show_icon = aff_conf && aff_conf.aff_id;
    const {t} = useTranslation() as any;
    return <div className={styles.afflp_hero}>
      <div className={styles.afflp_hero_arch_white}/>
      <div className={styles.afflp_hero_veil1}/>
      <div className={styles.afflp_hero_veil2}/>
      <div className={styles.afflp_hero_brands}>
        <div>
          <Svg icon={<Icon_netflix_logo width={78} height={22}/>}/>
          <Svg icon={<Icon_disney_logo width={73} height={40}/>}/>
          <Svg icon={<Icon_hulu_logo width={62} height={22}/>}/>
          <Svg icon={<Icon_prime_logo width={68} height={22}/>}/>
          <Svg icon={<Icon_youtube_logo width={92} height={22}/>}/>
          <Svg icon={<Icon_hbo_logo width={51} height={22}/>}/>
          <Svg icon={<Icon_netflix_logo width={78} height={22}/>}/>
          <Svg icon={<Icon_disney_logo width={73} height={40}/>}/>
          <Svg icon={<Icon_hulu_logo width={62} height={22}/>}/>
          <Svg icon={<Icon_prime_logo width={68} height={22}/>}/>
          <Svg icon={<Icon_youtube_logo width={92} height={22}/>}/>
          <Svg icon={<Icon_hbo_logo width={51} height={22}/>}/>
        </div>
        <i/>
      </div>
      <div className={styles.afflp_hero_content}>
        <div className={styles.afflp_hero_text}>
          <h1 className={styles.afflp_hero_heading}>
            <Trans i18nKey="promo_head_h1" components={{span: <span/>}}/>
          </h1>
          {sub_title && <h5>{sub_title}</h5>}
          <p className={styles.afflp_hero_price}>
            {fix ?
              <Fragment><span>${fix}</span>/ {t('month')}</Fragment> :
              <Fragment>
                {t('Start from')} <span>${from || 2.99}</span>/ {t('month')}
              </Fragment>}
          </p>
          <Button round to={`/premium?ref=${pref || 'afflp_hero'}`}
            size="lg" arrow width={310} caption={t('Get Hola')}
            cls={styles.hola_btn} on_click={()=>{
              perr({id: `www_get_hola_top_cta_click_${pref}`});
            }}/>
        </div>
        <div className={styles.afflp_hero_rating}>
          <div className={styles.afflp_hero_left}>
            {is_client && <Trustpilot two_lines/>}
          </div>
          <div className={styles.afflp_hero_middle}>
            <Trans>Trusted by</Trans>
            <strong><Trans>Over 200 million members</Trans></strong>
            <Trans>worldwide</Trans>
          </div>
          {show_icon && <div className={styles.afflp_hero_right}>
            {is_client && <Aff_icon aff_conf={aff_conf}/>}
          </div>}
        </div>
      </div>
    </div>;
};
